import { writable } from "svelte/store";

export const confirmState = writable({ message: "", resolve: null });

export function showConfirm(msg) {
    return new Promise((resolve) => {
        confirmState.update((state) => {
            if (state.resolve) state.resolve(false);
            return { message: String(msg ?? ""), resolve };
        });
    });
}

export function closeConfirm(result) {
    confirmState.update((state) => {
        if (state.resolve) state.resolve(result);
        return { message: "", resolve: null };
    });
}
